<template>
  <div class="artist">
    <div class="artist-heading">
      <h2>
        <span class="artist-name">{{artist.name}}</span>
      </h2>
      <p>
        <span class="artist-length">{{artist.work}}</span><br>
        <span class="artist-location">{{artist.about}}</span><br>
        <a :href="artist.href" target="_blank">{{artist.site}}</a>
      </p>
    </div>
    <div class="artist-detail">
      <figure>
          <img v-bind:src="'/static/img/'+artist.image" />
      </figure>
      <div class="" v-html="artist.copy"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'exhibit-item',
  props: ['artist']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ExhibitPage/ExhibitItem.vue?be2d1256